import { Controller } from "react-hook-form"
import { useRef } from "react"
import classNames from "classnames"
import styles from "./select-control.module.css"

export const SelectControl = ({
  className,
  control,
  name,
  label,
  options,
  placeholder,
  onSelect,
  required = false
}) => {
  const elemRef = useRef(null)

  return (
    <Controller
      {...{ control, name }}
      rules={{ required: required ? "Detta fält är obligatoriskt" : false }}
      render={({ field, fieldState }) => {
        return (
          <div
            className={classNames(styles.controller, className, {
              "has-value": fieldState.isDirty
            })}
            ref={elemRef}>
            <label htmlFor={name}>{label}</label>
            <select
              value={field.value}
              placeholder={placeholder || "Sök"}
              onChange={(value) => {
                field.onChange(value)
                onSelect(name, value.target.value)
              }}>
              {options.map((option, index) => (
                <option key={index} value={option.slug}>
                  {option.label}
                </option>
              ))}
            </select>
            <svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L9 1L4.98445 5L1 1Z" />
            </svg>
          </div>
        )
      }}
    />
  )
}
